import React from "react";

import { DashboardStatusTone } from "../Dashboard/shared/DashboardStatusBadge";

/** Mid-fi chip tones (UX-05): ok = energy / connected, warn = estimate or caveat, info = context,
 * alert = exposure, future = not yet available (dashed). */
export type MidFiChipTone = "ok" | "warn" | "info" | "alert" | "future";

const TONE_CLASSES: Record<MidFiChipTone, string> = {
  ok: "bg-mf-energy-soft text-mf-energy-ink",
  warn: "bg-mf-orange-soft text-mf-orange-ink",
  info: "bg-mf-slate-soft text-mf-slate",
  alert: "bg-mf-alert-soft text-mf-alert",
  future: "border border-dashed border-mf-faint bg-mf-future text-mf-faint",
};

/** Maps the shared dashboard status tones (KPI badges from the API) onto mid-fi chip tones. */
export const chipToneFromStatusTone = (tone?: DashboardStatusTone): MidFiChipTone => {
  switch (tone) {
    case "warning":
      return "warn";
    case "error":
      return "alert";
    case "info":
      return "info";
    default:
      return "future";
  }
};

interface IProps {
  label: string;
  tone?: MidFiChipTone;
  className?: string;
}

// NextGen-scoped rather than a restyle of the shared DashboardStatusBadge, which the main
// dashboard also renders.
export const MidFiChip = ({ label, tone = "info", className = "" }: IProps) => (
  <span
    className={`inline-block rounded-full px-2.5 py-0.5 leading-snug text-[10px] font-extrabold uppercase tracking-wide ${TONE_CLASSES[tone]} ${className}`}
  >
    {label}
  </span>
);
